<template>
  <div>
    <v-dialog v-model="show" scrollable persistent max-width="1200">
      <v-card>
        <v-card-title>
          <v-row xs12>
            <v-col class="py-0">Add Rates</v-col>
          </v-row>

          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <dates-range-picker
                  :gt-date-from-string="dateFrom"
                  :gt-date-to-string="dateTo"
                  @onRangeSelected="onDatesRangeSelected($event)"
                ></dates-range-picker>
              </v-flex>
              <v-flex xs12 sm5>
                <v-text-field
                  label="Rate Plan"
                  v-model="ratePlan"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm1>
                <v-text-field
                  label="Markup %"
                  v-model.number="markup"
                  type="number"
                  min="0"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 sm4>
                <gt-multi-select
                  :items="rateTypes"
                  v-model="selectedRateTypes"
                  item-text="name"
                  item-value="code"
                  label="Rate Type"
                  :show-selected="1"
                ></gt-multi-select>
              </v-flex>
              <v-flex xs12 sm4>
                <gt-multi-select
                  :items="services"
                  v-model="selectedServices"
                  item-text="node.name"
                  item-value="node"
                  label="Service"
                  :show-selected="1"
                ></gt-multi-select>
              </v-flex>
              <v-flex xs12 sm4>
                <gt-multi-select
                  :items="agentGroups"
                  v-model="selectedAgentGroups"
                  item-text="name"
                  item-value="id"
                  label="Agent Group"
                  :show-selected="1"
                ></gt-multi-select>
              </v-flex>
            </v-layout>
          </v-container>

          <v-layout justify-center>
            <v-btn small @click="onAdd" :disabled="disabledAdd" class="mr-2"
              >Add Season</v-btn
            >
            <v-btn small @click="onNextSeasonAdd" :disabled="isRatesItemsEmpty"
              >Next Season</v-btn
            >
          </v-layout>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <div v-for="key in Object.keys(this.seasons)" :key="key">
            <v-layout align-center pt-3>
              <v-flex sm6>
                <!-- <h5 class="headline text-xs-left pa-3">
                  Season: (From: {{seasons[key][0].dateFrom | formatDate}}, To:
                  {{seasons[key][0].dateTo | formatDate}})
                </h5>-->
              </v-flex>
              <v-flex>
                <dates-range-picker
                  :gt-date-from-string="seasons[key][0].dateFrom"
                  :gt-date-to-string="seasons[key][0].dateTo"
                  @onRangeSelected="onSeasonDateRangeChange(key)($event)"
                ></dates-range-picker>
              </v-flex>
              <v-flex>
                <v-layout justify-end>
                  <v-chip close @click:close="clearSeason(key)">Remove</v-chip>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-card>
              <v-list two-line>
                <template v-for="(item, index) in seasons[key]">
                  <v-divider
                    v-if="index !== 0"
                    :key="`${item.id}-divider`"
                  ></v-divider>
                  <supplier-rates-add-list-item
                    :key="`${item.id}`"
                    :rateTypes="rateTypes"
                    v-model="
                      ratesItems[ratesItems.findIndex((i) => i.id == item.id)]
                    "
                    @edit="onEditListItem($event)"
                  ></supplier-rates-add-list-item>
                </template>
              </v-list>
            </v-card>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-container grid-list-md>
            <v-layout justify-center>
              <v-btn
                color="success"
                small
                v-show="validRates.length != 0"
                @click="saveRates"
                >Save</v-btn
              >
              <v-btn
                class="mx-2"
                small
                v-show="!isRatesItemsEmpty"
                @click="clearAllSeasons"
                >Remove All</v-btn
              >
              <v-btn small @click="$emit('onClose')">Close</v-btn>
            </v-layout>
            <div v-if="debug">[{{ validRates }}]</div>
          </v-container>
        </v-card-actions>
        <v-dialog
          v-model="supplierRatePriceEditorDialog"
          scrollable
          persistent
          max-width="1220"
        >
          <v-card>
            <price-details-editor
              :rate-types="rateTypes"
              :agent-groups="agentGroups"
              v-model="editedRateItem"
              @onCloseDialog="supplierRatePriceEditorDialog = false"
              @input="updateRateItem"
            ></price-details-editor>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DatesRangePicker from "../../../shared/DatesRangePicker";
import GtMultiSelect from "../../../shared/GtMultiSelect";
import PriceDetailsEditor from "../edit/price-details/PriceDetailsEditor";
import { SUPPLIER_PRICES_CREATE_MUTATION } from "../../../../../constants/graphql";
import gql from "graphql-tag";
import SupplierRatesAddListItem from "./SupplierRatesAddListItem";
import EventBus from "../../../../../store/event-bus";
import { sortByFn } from "../../../../../helpers/index";
import {
  priceMapper,
  priceIsValid,
} from "../edit/price-details/price-properties";

const moment = require("moment");
const randomize = require("randomatic");

export const QUERY = gql`
  query supplierRatesAddRateTypes($supplierId: ID!) {
    rateTypes {
      totalCount
      edges {
        node {
          id
          code
          name
          includePax
        }
      }
    }
    agentGroups(
      filter: { isAgent: true }
      orderBy: { fieldName: "name", direction: ASC }
    ) {
      edges {
        node {
          id
          name
        }
      }
    }
    supplier(id: $supplierId) {
      id
      currencyCode
      defaultRateTypeCode
      extrasChildPrice
      services(orderBy: { fieldName: "name", direction: ASC }) {
        totalCount
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export default {
  name: "SupplierRates",
  components: {
    SupplierRatesAddListItem,
    DatesRangePicker,
    PriceDetailsEditor,
    GtMultiSelect,
  },
  props: {
    supplierId: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      debug: false,
      dateFrom: moment().toISOString(true),
      dateTo: moment().add(30, "days").toISOString(true),
      dateToRangeStart: "",
      dateToRangeEnd: "",
      selectedRateTypes: [],
      selectedServices: [],
      selectedAgentGroups: [""],
      markup: 0,
      ratesItems: [],
      ratesData: null,
      ratePlan: "",
      supplierRatePriceEditorDialog: false,
      editedRateItem: {},
      seasonCounter: 0,
    };
  },
  methods: {
    onDatesRangeSelected(data) {
      this.dateTo = data.dateTo;
      this.dateFrom = data.dateFrom;
    },
    saveRates() {
      this.$apollo
        .mutate({
          mutation: SUPPLIER_PRICES_CREATE_MUTATION,
          variables: {
            prices: this.ratesToSave,
          },
        })
        .then((data) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Rates Saved",
          });
          EventBus.$emit("refetch-supplier-rates");
          this.$emit("savedRates");
        });
    },
    onAdd() {
      const seasonId = `${this.seasonCounter}_${randomize("Aa0", 32)}`;
      this.seasonCounter++;
      for (let service of this.selectedServices) {
        for (let rateType of this.selectedRateTypes) {
          this.ratesItems.push({
            id: randomize("Aa0", 32),
            serviceId: service.id,
            serviceName: service.name,
            rateTypeCode: rateType,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            markup: this.markup,
            ratePlan: this.ratePlan,
            currencyCodeBuy: this.ratesData.supplier.currencyCode,
            currencyCodeSell: this.ratesData.supplier.currencyCode,
            seasonId: seasonId,
          });
        }
      }
    },
    onNextSeasonAdd() {
      const lastDateFrom = moment(this.dateFrom);
      const lastDateTo = moment(this.dateTo);
      const lastDuration = lastDateTo.diff(lastDateFrom, "days");

      this.dateFrom = lastDateTo.add(1, "days").toISOString(true);
      this.dateTo = lastDateTo.add(lastDuration, "days").toISOString(true);

      this.onAdd();
    },
    clearSeason(seasonId) {
      this.ratesItems = this.ratesItems.filter(
        (item) => item.seasonId != seasonId
      );
    },
    clearAllSeasons() {
      this.ratesItems = [];
    },
    onSeasonDateRangeChange(season) {
      return (dateRange) => {
        this.ratesItems = [
          ...this.ratesItems.filter((item) => item.seasonId != season),
          ...this.ratesItems
            .filter((item) => item.seasonId == season)
            .map((item) => ({ ...item, ...dateRange })),
        ];
      };
    },
    onEditListItem(item) {
      this.editedRateItem = { ...item };
      this.supplierRatePriceEditorDialog = true;
    },
    updateRateItem() {
      this.ratesItems = this.ratesItems.filter((rate) => {
        return rate.id !== this.editedRateItem.id;
      });

      this.ratesItems = [...this.ratesItems, this.editedRateItem];

      this.editedRateItem = {};
      this.supplierRatePriceEditorDialog = false;
    },
  },

  computed: {
    disabledAdd() {
      return (
        this.selectedServices.length == 0 ||
        this.selectedRateTypes.length == 0 ||
        this.selectedAgentGroups.length == 0
      );
    },
    isRatesItemsEmpty() {
      return this.ratesItems.length == 0;
    },
    seasons() {
      const ratesGroupedBySeasons = this.ratesItems
        .sort(sortByFn((item) => item.seasonId + item.id))
        .reduce((group, item) => {
          group[item.seasonId] = group[item.seasonId] || [];
          group[item.seasonId].push(item);
          return group;
        }, {});

      return ratesGroupedBySeasons;
    },
    validRates() {
      return this.ratesItems
        .filter((item) => item.checked && priceIsValid(item))
        .map(priceMapper);
    },
    ratesToSave() {
      return this.selectedAgentGroups.reduce(
        (rates, agentGroupId) => [
          ...rates,
          ...this.validRates.map((rate) => ({
            ...rate,
            groupId: agentGroupId,
          })),
        ],
        []
      );
    },
    agentGroups() {
      if (this.ratesData) {
        return [
          { name: "All Groups", id: "" },
          ...this.ratesData.agentGroups.edges.map((a) => a.node),
        ];
      } else {
        return [];
      }
    },

    rateTypes() {
      if (this.ratesData) {
        return this.ratesData.rateTypes.edges.map((rt) => rt.node);
      } else {
        return [];
      }
    },
    services() {
      if (this.ratesData) {
        return this.ratesData.supplier.services.edges.map((s) => s);
      } else {
        return [];
      }
    },
  },
  apollo: {
    supplier: {
      query: QUERY,
      variables() {
        return {
          supplierId: this.supplierId,
        };
      },
      skip() {
        return this.supplierId ? false : true;
      },
      fetchPolicy: "network-only",
      result({ data }) {
        this.ratesData = data;
        this.selectedRateTypes =
          data.supplier.defaultRateTypeCode.trim() != ""
            ? [data.supplier.defaultRateTypeCode]
            : [];
        this.selectedServices = this.ratesData.supplier.services.edges.map(
          (s) => s.node
        );
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/add/SupplierRatesAdd.vue